import getMessage from 'src/background/utils/i18n.utils';
import React, { useState } from 'react';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
export const WalletInfoSectionItemButton = ({ handleClick, actionButton, }) => {
    const [hovered, setHovered] = useState(false);
    return (React.createElement("div", { className: "wallet-action-button", onClick: ($event) => handleClick($event, actionButton), onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false) },
        React.createElement(SVGIcon, { icon: actionButton.icon, className: "action-icon", hoverable: true, forceHover: hovered }),
        React.createElement("div", { className: "title" }, getMessage(actionButton.label, actionButton.labelParams))));
};
